/* Just Brilliant: align prices without stretching copy beside an open quick shop. */
if (!customElements.get('jb-catalog-layout')) {
  customElements.define('jb-catalog-layout', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.observed = new Set();
      this.schedule = () => {
        if (!this.frame && this.isConnected) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.align();
        });
      };
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
      document.fonts?.ready.then(this.schedule);
      this.schedule();
    }
    align() {
      const grid = this.querySelector('#product-grid');
      if (grid) {
        const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
        const products = [...grid.children].filter(node => node.querySelector('product-card'));
        for (const story of grid.querySelectorAll(':scope > [data-jb-story-after]')) {
          const after = Math.min(products.length, Math.ceil(Number(story.dataset.jbStoryAfter || 6) / columns) * columns);
          const anchor = products[after];
          if (anchor && story.nextElementSibling !== anchor) grid.insertBefore(story, anchor);
          else if (!anchor && story !== grid.lastElementChild) grid.append(story);
        }
      }
      const copies = [...this.querySelectorAll('.jb-card-copy__inner')];
      const current = new Set(copies);
      for (const copy of this.observed) {
        if (!current.has(copy)) this.resize.unobserve(copy);
      }
      for (const copy of copies) {
        if (!this.observed.has(copy)) this.resize.observe(copy);
      }
      this.observed = current;
      const rows = [];
      // Read only natural text heights: a quick-shop panel never participates.
      for (const copy of copies) {
        const card = copy.closest('product-card');
        const rect = card.getBoundingClientRect();
        if (!rect.width) continue;
        let row = rows.find(item => Math.abs(item.top - rect.top) < 2);
        if (!row) rows.push(row = { top: rect.top, height: 0, cards: [] });
        row.height = Math.max(row.height, Math.ceil(copy.getBoundingClientRect().height));
        row.cards.push(card);
      }
      for (const row of rows) {
        for (const card of row.cards) {
          const value = `${row.height}px`;
          if (card.style.getPropertyValue('--jb-copy-height') !== value) {
            card.style.setProperty('--jb-copy-height', value);
          }
        }
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.resize?.disconnect();
      this.observer?.disconnect();
      this.observer = null;
    }
  });
}

